import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { css } from "@vitality-ds/system";
import { BaseTypography } from "../../Typography/styled";
import { BaseCalloutDescription } from "../components/CalloutDescription/styled";
export default css({
  display: "flex",
  flex: 1,
  gap: "$md",
  alignItems: "flex-start",
  svg: {
    flexShrink: 0
  },
  variants: {
    size: {
      compact: {
        gap: "$sm"
      },
      blockCompact: {
        gap: "$sm",
        "& div": _defineProperty({}, "& > ".concat(BaseTypography, ", & > ").concat(BaseCalloutDescription), {
          marginRight: "$sm"
        })
      },
      "default": {}
    }
  }
});